// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3bC5t","alert":"SettungsInbox_alert__3L9Bh"};